"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeGetListingView = exports.makeGetListingViewFetchStatus = exports.makeGetListingViewFetchError = void 0;

var _reselect = require("reselect");

var RequestState = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/RequestState"));

var getSlugFromProps = function getSlugFromProps(_, props) {
  return props.slug;
};

var getListingViewsCache = function getListingViewsCache(state) {
  return state.details.get('listingViewsCache');
};

var getListingViewsFetchErrorCache = function getListingViewsFetchErrorCache(state) {
  return state.details.get('listingViewsFetchErrorCache');
};

var getListingViewsFetchStatusCache = function getListingViewsFetchStatusCache(state) {
  return state.details.get('listingViewsFetchStatusCache');
};

var makeGetListingViewFetchError = function makeGetListingViewFetchError() {
  return (0, _reselect.createSelector)([getSlugFromProps, getListingViewsFetchErrorCache], function (slug, listingViewsFetchErrorCache) {
    return listingViewsFetchErrorCache.get(slug);
  });
};

exports.makeGetListingViewFetchError = makeGetListingViewFetchError;

var makeGetListingViewFetchStatus = function makeGetListingViewFetchStatus() {
  return (0, _reselect.createSelector)([getSlugFromProps, getListingViewsFetchStatusCache], function (slug, listingViewsFetchStatusCache) {
    return listingViewsFetchStatusCache.get(slug, RequestState.UNINITIALIZED);
  });
};

exports.makeGetListingViewFetchStatus = makeGetListingViewFetchStatus;

var makeGetListingView = function makeGetListingView() {
  return (0, _reselect.createSelector)([getSlugFromProps, getListingViewsCache], function (slug, listingViewsCache) {
    return listingViewsCache.get(slug);
  });
};

exports.makeGetListingView = makeGetListingView;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/details.js
// module id = 208
// module chunks = 209 210 211 212